import { BehaviorContext } from '../../behavior-context';
import { Behavior } from '../../behavior';
import { SESSION_KEY_LEASE_APPLICATION } from './constants';
import { Injectable } from '@angular/core';

@Injectable()
export class SaveApplicationBehavior implements Behavior {
  async execute(args: any, context: BehaviorContext): Promise<any> {
    // Temporarily store in session storage
    const formValue = context.formGroup.value;

    let existingData = JSON.parse(
      sessionStorage.getItem(SESSION_KEY_LEASE_APPLICATION)
    );
    existingData = { ...existingData, ...formValue };
    sessionStorage.setItem(
      SESSION_KEY_LEASE_APPLICATION,
      JSON.stringify(existingData)
    );
  }
}
